// Estilos compartilhados das telas do Snapshot Watcher.
//
// O <Box component="main"> do MainFrame pinta o fundo por conta propria e, na
// pratica, renderiza escuro. A TopologyPage convive com isso pintando as
// proprias superficies — mesma convencao aqui, senao um Paper "outlined" fica
// transparente e o conteudo some no escuro.
//
// Ficava duplicado em cada tela; com seis telas isso vira divergencia garantida
// (uma ganha um ajuste, as outras nao).

export const SUPERFICIE = {
  bgcolor: '#ffffff',
  color: '#0f172a',
  '& .MuiTypography-root': { color: '#0f172a' },
  '& .MuiTypography-caption': { color: '#475569' },
  '& .MuiInputBase-root': { bgcolor: '#ffffff' },
  '& .MuiInputLabel-root': { color: '#475569' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
  '& .MuiSvgIcon-root': { color: '#475569' },
};

/** Cor por categoria de fact. Mesma paleta do CompareEventos. */
export const COR_CATEGORIA = {
  OSPF: '#9b59b6',
  BGP: '#e67e22',
  ISIS: '#2980b9',
  MPLS: '#2dd4bf',
  INTERFACE: '#8e44ad',
  L2: '#3498db',
  HW: '#c0392b',
  OUTROS: '#7f8c8d',
};

/** Cor por status de run. */
export const COR_STATUS = {
  pending: '#64748b',
  running: '#2563eb',
  done: '#16a085',
  error: '#c0392b',
};

export const ROTULO_STATUS = {
  pending: 'Na fila',
  running: 'Coletando',
  done: 'Concluído',
  error: 'Erro',
};

export const ROTULO_FASE = {
  before: 'Antes',
  after: 'Depois',
  periodic: 'Periódico',
};

/** Lê um item de storage sem estourar quando o JSON está corrompido. */
export function getItem(storage, key) {
  try {
    return JSON.parse(storage.getItem(key));
  } catch {
    return null;
  }
}

/** Data legível em pt-BR; devolve travessão quando não há valor. */
export function fmtData(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString('pt-BR');
}

/**
 * Superficie de codigo e saida de equipamento.
 *
 * Era quase preto (#0f172a). Num app de fundo claro isso vira um retangulo de
 * contraste altissimo que puxa o olho para o lugar errado e cansa em tela cheia
 * de comando. Cinza bem claro com texto escuro le igual e some no resto da
 * pagina — a informacao continua sendo o texto, nao a caixa.
 */
export const CODIGO = {
  bgcolor: '#f8fafc',
  color: '#1e293b',
  border: '1px solid #e2e8f0',
  borderRadius: 1,
  p: 1.25,
  fontFamily: 'monospace',
  fontSize: 12,
  lineHeight: 1.55,
};

/** Cores das linhas de um diff unificado, na mesma chave clara. */
export const COR_DIFF = {
  cabecalho: { color: '#94a3b8' },
  trecho: { color: '#7c3aed', bgcolor: '#faf5ff', fontWeight: 600 },
  // Verde e vermelho BEM claros, no tom que se usa em revisao de codigo. O peso
  // fica na barra lateral colorida, nao no fundo: fundo forte em dezenas de
  // linhas seguidas vira parede e cansa antes da terceira tela de comando.
  adicionada: { color: '#166534', bgcolor: '#f0fdf4', borderLeft: '3px solid #86efac' },
  removida: { color: '#991b1b', bgcolor: '#fef2f2', borderLeft: '3px solid #fca5a5' },
  host: { color: '#92400e', bgcolor: '#fffbeb', fontWeight: 700 },
  contexto: { color: '#64748b', borderLeft: '3px solid transparent' },
};
